import { nanoid } from 'nanoid';
import { BaseRange, Editor, Node } from 'slate';

import { BuiltInComponents } from 'craft/constants';

export const wrapVariable = (editor: Editor, name: string, fallback: string, range?: BaseRange) => {
  const id = nanoid(6);
  const newText: Node = ({
    children: [{ text: name }],
    type: BuiltInComponents.Variable,
    variable: {
      id,
      name,
      fallback,
    },
  } as unknown) as Node; // TODO-variables: We can extend node type with our custom mark

  if (range) {
    // eslint-disable-next-line no-param-reassign
    editor.selection = range;
  }
  editor.insertNode(newText);
};
